/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';

/**
 * 
 * @export
 * @interface MiniOrganization
 */
export interface MiniOrganization {
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    group_name: string;
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    group_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    connect_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    ops_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    respond_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    subscribed_user_auth_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    unsubscribed_user_auth_ids: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    allow_group_location_tracking: boolean;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof MiniOrganization
     */
    roles_with_features: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof MiniOrganization
     */
    all_group_names: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    subscription_end_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    subscription_start_timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    trial_end_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    ops_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    respond_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    ops_seats_used: number;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    respond_seats_used: number;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    org_has_ops_inventory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    org_has_respond_inventory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    org_has_any_paid_inventory: boolean;
    /**
     * 
     * @type {SubscriptionTier}
     * @memberof MiniOrganization
     */
    effective_tier: SubscriptionTier;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    can_send_emergency: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    can_view_emergency_map: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    can_view_map: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    can_be_assigned_to_pvd_config: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MiniOrganization
     */
    can_be_assigned_to_respond_config: boolean;
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MiniOrganization
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof MiniOrganization
     */
    _ts: number;
}



/**
 * Check if a given object implements the MiniOrganization interface.
 */
export function instanceOfMiniOrganization(value: object): value is MiniOrganization {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('company_name' in value) || value['company_name'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('connect_user_auth_ids' in value) || value['connect_user_auth_ids'] === undefined) return false;
    if (!('ops_user_auth_ids' in value) || value['ops_user_auth_ids'] === undefined) return false;
    if (!('respond_user_auth_ids' in value) || value['respond_user_auth_ids'] === undefined) return false;
    if (!('subscribed_user_auth_ids' in value) || value['subscribed_user_auth_ids'] === undefined) return false;
    if (!('unsubscribed_user_auth_ids' in value) || value['unsubscribed_user_auth_ids'] === undefined) return false;
    if (!('allow_group_location_tracking' in value) || value['allow_group_location_tracking'] === undefined) return false;
    if (!('roles_with_features' in value) || value['roles_with_features'] === undefined) return false;
    if (!('all_group_names' in value) || value['all_group_names'] === undefined) return false;
    if (!('subscription_end_timestamp' in value) || value['subscription_end_timestamp'] === undefined) return false;
    if (!('subscription_start_timestamp' in value) || value['subscription_start_timestamp'] === undefined) return false;
    if (!('ops_subscription_count' in value) || value['ops_subscription_count'] === undefined) return false;
    if (!('respond_subscription_count' in value) || value['respond_subscription_count'] === undefined) return false;
    if (!('ops_seats_used' in value) || value['ops_seats_used'] === undefined) return false;
    if (!('respond_seats_used' in value) || value['respond_seats_used'] === undefined) return false;
    if (!('org_has_ops_inventory' in value) || value['org_has_ops_inventory'] === undefined) return false;
    if (!('org_has_respond_inventory' in value) || value['org_has_respond_inventory'] === undefined) return false;
    if (!('org_has_any_paid_inventory' in value) || value['org_has_any_paid_inventory'] === undefined) return false;
    if (!('effective_tier' in value) || value['effective_tier'] === undefined) return false;
    if (!('can_send_emergency' in value) || value['can_send_emergency'] === undefined) return false;
    if (!('can_view_emergency_map' in value) || value['can_view_emergency_map'] === undefined) return false;
    if (!('can_view_map' in value) || value['can_view_map'] === undefined) return false;
    if (!('can_be_assigned_to_pvd_config' in value) || value['can_be_assigned_to_pvd_config'] === undefined) return false;
    if (!('can_be_assigned_to_respond_config' in value) || value['can_be_assigned_to_respond_config'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function MiniOrganizationFromJSON(json: any): MiniOrganization {
    return MiniOrganizationFromJSONTyped(json, false);
}

export function MiniOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiniOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'company_name': json['company_name'],
        'group_name': json['group_name'],
        'group_id': json['group_id'],
        'connect_user_auth_ids': json['connect_user_auth_ids'],
        'ops_user_auth_ids': json['ops_user_auth_ids'],
        'respond_user_auth_ids': json['respond_user_auth_ids'],
        'subscribed_user_auth_ids': json['subscribed_user_auth_ids'],
        'unsubscribed_user_auth_ids': json['unsubscribed_user_auth_ids'],
        'allow_group_location_tracking': json['allow_group_location_tracking'],
        'roles_with_features': json['roles_with_features'],
        'all_group_names': json['all_group_names'],
        'subscription_end_timestamp': json['subscription_end_timestamp'],
        'subscription_start_timestamp': json['subscription_start_timestamp'],
        'trial_end_timestamp': json['trial_end_timestamp'] == null ? undefined : json['trial_end_timestamp'],
        'ops_subscription_count': json['ops_subscription_count'],
        'respond_subscription_count': json['respond_subscription_count'],
        'ops_seats_used': json['ops_seats_used'],
        'respond_seats_used': json['respond_seats_used'],
        'org_has_ops_inventory': json['org_has_ops_inventory'],
        'org_has_respond_inventory': json['org_has_respond_inventory'],
        'org_has_any_paid_inventory': json['org_has_any_paid_inventory'],
        'effective_tier': SubscriptionTierFromJSON(json['effective_tier']),
        'can_send_emergency': json['can_send_emergency'],
        'can_view_emergency_map': json['can_view_emergency_map'],
        'can_view_map': json['can_view_map'],
        'can_be_assigned_to_pvd_config': json['can_be_assigned_to_pvd_config'],
        'can_be_assigned_to_respond_config': json['can_be_assigned_to_respond_config'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function MiniOrganizationToJSON(json: any): MiniOrganization {
    return MiniOrganizationToJSONTyped(json, false);
}

export function MiniOrganizationToJSONTyped(value?: MiniOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'company_name': value['company_name'],
        'group_name': value['group_name'],
        'group_id': value['group_id'],
        'connect_user_auth_ids': value['connect_user_auth_ids'],
        'ops_user_auth_ids': value['ops_user_auth_ids'],
        'respond_user_auth_ids': value['respond_user_auth_ids'],
        'subscribed_user_auth_ids': value['subscribed_user_auth_ids'],
        'unsubscribed_user_auth_ids': value['unsubscribed_user_auth_ids'],
        'allow_group_location_tracking': value['allow_group_location_tracking'],
        'roles_with_features': value['roles_with_features'],
        'all_group_names': value['all_group_names'],
        'subscription_end_timestamp': value['subscription_end_timestamp'],
        'subscription_start_timestamp': value['subscription_start_timestamp'],
        'trial_end_timestamp': value['trial_end_timestamp'],
        'ops_subscription_count': value['ops_subscription_count'],
        'respond_subscription_count': value['respond_subscription_count'],
        'ops_seats_used': value['ops_seats_used'],
        'respond_seats_used': value['respond_seats_used'],
        'org_has_ops_inventory': value['org_has_ops_inventory'],
        'org_has_respond_inventory': value['org_has_respond_inventory'],
        'org_has_any_paid_inventory': value['org_has_any_paid_inventory'],
        'effective_tier': SubscriptionTierToJSON(value['effective_tier']),
        'can_send_emergency': value['can_send_emergency'],
        'can_view_emergency_map': value['can_view_emergency_map'],
        'can_view_map': value['can_view_map'],
        'can_be_assigned_to_pvd_config': value['can_be_assigned_to_pvd_config'],
        'can_be_assigned_to_respond_config': value['can_be_assigned_to_respond_config'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

